import React, { Component } from "react";
import Functions from "../../src/functions";
import Manager from "../../src/manager";

class Module extends Component {
  state = {
    name: "",
    id: "",
    placeholder: "",
    value: "",
    defaultValue: "",
    loaded: false,
    editable: true,
    attributes: "",
    events: {},
  };

  constructor(props) {
    super(props);

    this.customUI = this.customUI.bind(this);

    let defaultValue = "";
    if (this.props.property.defaultValue) {
      defaultValue = this.props.property.defaultValue;
    }

    let module = "";
    let view = "";
    let customParameters = { replace: {}, headers: {} };
    let inputData = [];
    let parentData = [];
    this.manager = React.createRef();

    if (this.props.property.configuration) {
      module = this.props.property.configuration.module
        ? this.props.property.configuration.module
        : module;
      view = this.props.property.configuration.view
        ? this.props.property.configuration.view
        : view;
      customParameters = this.props.property.configuration.customParameters
        ? this.props.property.configuration.customParameters
        : customParameters;
      inputData = this.props.property.configuration.inputData
        ? this.props.property.configuration.inputData
        : inputData;
      parentData = this.props.property.configuration.parentData
        ? this.props.property.configuration.parentData
        : this.props.data;
    }

    this.state = {
      module: module,
      view: view,
      customParameters: customParameters,
      inputData: inputData,
      parentData: parentData,
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      defaultValue: this.props.value ? this.props.value : defaultValue,
    };
  }

  componentDidMount() {
    this.setState({
      attributes: this.props.property.attributes,
      name: this.props.property.alias,
      loaded: true,
      placeholder: this.props.property.placeholder
        ? this.props.property.placeholder
        : "",

      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      customUI: this.props.property.customUI,
      useCustomUI:
        typeof this.props.property.useCustomUI !== "undefined"
          ? this.props.property.useCustomUI
          : true,
    });
    if (this.didMount) {
      this.didMount();
    }
  }

  customUI(control) {
    if (this.state.customUI && this.state.useCustomUI == true) {
      this.state.customUI = this.state.customUI.bind(this);
      return this.state.customUI({ control: control, object: this });
    }

    return control;
  }

  render() {
    if (this.state.loaded) {
      let control = (
        <Manager
          ref={this.manager}
          module={this.state.module}
          view={this.state.view}
          customParameters={this.state.customParameters}
          inputData={this.state.inputData}
          parentData={this.state.parentData}
        ></Manager>
      );

      return this.customUI(control);
    }
    return "";
  }
}

export default Module;
